import React, { useMemo, useState } from "react";
import { RepeatedTimeRangeModalComponent } from "@iventis/repeated-time-ranges";
import { MapObjectRepeatedTimeRangeValue } from "@iventis/types";
import { useDispatch, useSelector } from "react-redux";
import { SystemDataFieldName } from "@iventis/domain-model/model/systemDataFieldName";
import { parseRepeatedTimeRangeDataFieldValueToNumber } from "@iventis/utilities";
import { RootDispatch, RootState } from "../state/root.store";
import { MapObjectRowNodeData } from "./sidebar-data-table.types";
import { patchMapObjectsDataFieldValues } from "../state/map.slice.thunks";

interface SidebarBarDataTableRepeatedTimeRangeProps {
    dataFieldId: string;
    rowData: MapObjectRowNodeData;
    onClose: () => void;
}

export const SidebarBarDataTableRepeatedTimeRangeComponent = ({ dataFieldId, rowData, onClose }: SidebarBarDataTableRepeatedTimeRangeProps) => {
    const dispatch: RootDispatch = useDispatch();

    const [saving, setSaving] = useState(false);

    const { layers } = useSelector((state: RootState) => ({
        layers: state.mapReducer.mapModule.layers.value,
    }));

    // Parse the initial values so they are in the correct format
    const initialValues = useMemo(() => parseRepeatedTimeRangeDataFieldValueToNumber(rowData.dataFieldValues[dataFieldId] ?? []), []);

    // Layer the datafield belongs to
    const selectedLayer = layers.find((layer) => layer.id === rowData.layerId);

    // Get the map object name datafield
    const mapObjectNameDf = selectedLayer?.dataFields.find((df) => df.systemDataFieldName === SystemDataFieldName.MapObjectName);

    // Get the selected datafield
    const selectedDataField = selectedLayer?.dataFields.find((df) => df.id === dataFieldId);

    const handleSave = async (values: MapObjectRepeatedTimeRangeValue[]) => {
        setSaving(true);
        const mapObject = {
            id: rowData.id,
            layerId: rowData.layerId,
            dataFieldValues: { ...rowData.dataFieldValues, [dataFieldId]: values },
            geoJsonFeature: rowData.geoJsonFeature,
        };
        await dispatch(patchMapObjectsDataFieldValues({ mapObjects: [mapObject] }));
        setSaving(false);
        onClose();
    };

    return (
        <div>
            <RepeatedTimeRangeModalComponent
                mapObjectName={rowData.dataFieldValues[mapObjectNameDf?.id]}
                layerName={selectedLayer?.name}
                attributeName={selectedDataField.name}
                initialValues={initialValues ?? []}
                saving={saving}
                onSave={handleSave}
                onClose={onClose}
                onAttributeSettingsClicked={undefined}
            />
        </div>
    );
};
